module.exports = __webpack_public_path__ + "static/media/nouvel-obs.db762fff.png";